import { STATUS_ICON_CHECK_O, STATUS_ICON_INACTIVE, STATUS_ICON_WARNING } from '@/common/utils/statuses';
import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';
import { FloatingIp } from '@schema';

type FloatingIpStatusMap = Record<FloatingIp.status, StatusData>

// eslint-disable-next-line import/prefer-default-export
export const FLOATING_IP_STATUS_MAP = computedLocale<FloatingIpStatusMap>(() => ({
  [FloatingIp.status.ACTIVE]: {
    icon: STATUS_ICON_CHECK_O,
    text: i18n.t('Active'),
  },
  [FloatingIp.status.ERROR]: {
    icon: STATUS_ICON_WARNING,
    text: i18n.t('Error'),
  },
  [FloatingIp.status.DOWN]: {
    icon: STATUS_ICON_INACTIVE,
    text: i18n.t('Inactive'),
  }
}));
